import axios from 'axios';
import PathManagement from '../common/path-management';
import CatalogueView from './catalogo';
import { decryptResponse } from '../security/cryptojs-aes-format.js';
import { getResponseByUrl } from '../common/xhr';

export default class AlternativeIdentityXHR{
 
    data: DataForResponse;

    async getAlternativeIdentity(email): Promise<DataForResponse> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getAlternativeIdentity(email);
        try {
            this.data =  await getResponseByUrl(url);;
        } catch (err) {
            console.error(err, 'error al intentar recuperar insumos');
        }

        return this.data;
    }

    async getBackIdentity(): Promise<DataForResponse> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getBackIdentity();
        try {
            this.data =  await getResponseByUrl(url);;
        } catch (err) {
            console.error(err, 'error al intentar recuperar insumos');
        }

        return this.data;
    }



}

export interface DataForResponse{
    data: any;
}